const SEED_LOGS = [
  {
    id: 1,
    name: 'Aarav Rohit Sharma',
    date: '2026-08-19 14:32:10',
    module: 'Login',
    remarks: 'Logged in via Android Mobile App (Device: Samsung Galaxy S23, IP: 103.45.12.8)',
  },
  {
    id: 2,
    name: 'Pooja Anand Deshmukh',
    date: '2026-08-19 14:15:00',
    module: 'Lecture',
    remarks: 'Viewed lecture session recordings & downloaded study notes for "Corporate Restructuring"',
  },
  {
    id: 3,
    name: 'Rohan K. Varma',
    date: '2026-08-19 13:50:22',
    module: 'Test performance',
    remarks: 'Viewed answer key and scorecard for "JEE Advanced Mock Exam 4"',
  },
  {
    id: 4,
    name: 'Ananya S. Iyer',
    date: '2026-08-19 12:40:15',
    module: 'Fee',
    remarks: 'Viewed tuition fee installment schedule and downloaded payment receipt #RCP-8841',
  },
  {
    id: 5,
    name: 'Kunal M. Patil',
    date: '2026-08-19 11:20:44',
    module: 'Attendance',
    remarks: 'Checked monthly attendance summary & biometric punch-in logs for July-August 2026',
  },
  {
    id: 6,
    name: 'Sneha Rajesh Nair',
    date: '2026-08-19 10:05:12',
    module: 'Photo Gallery',
    remarks: 'Browsed institutional photo album "Annual Science Exhibition & Innovation Summit 2026"',
  },
  {
    id: 7,
    name: 'Vikram J. Mehta',
    date: '2026-08-18 17:45:30',
    module: 'Feedback',
    remarks: 'Submitted student feedback regarding air-conditioning issue in Room 204',
  },
  {
    id: 8,
    name: 'Divya P. Joshi',
    date: '2026-08-18 16:30:19',
    module: 'Notice Board',
    remarks: 'Read circular: "Independence Day Holiday & Special Lecture Schedule"',
  },
  {
    id: 9,
    name: 'Aditya N. Kulkarni',
    date: '2026-08-18 15:10:08',
    module: 'Syllabus',
    remarks: 'Downloaded curriculum outline for "Organic Chemistry - Reaction Mechanisms"',
  },
  {
    id: 10,
    name: 'Neha R. Gupta',
    date: '2026-08-18 14:02:55',
    module: 'Events',
    remarks: 'Viewed event details for "Inter-College Robotics Competition 2026"',
  },
  {
    id: 11,
    name: 'Aarav Rohit Sharma',
    date: '2026-08-18 11:15:20',
    module: 'Logout',
    remarks: 'Logged out from Android Mobile App session',
  },
]

function getStoredLogs() {
  try {
    const raw = localStorage.getItem('cloud_student_logs')
    if (!raw) {
      localStorage.setItem('cloud_student_logs', JSON.stringify(SEED_LOGS))
      return SEED_LOGS
    }
    return JSON.parse(raw)
  } catch {
    return SEED_LOGS
  }
}

export async function fetchStudentLogs(filters = {}) {
  await new Promise((resolve) => setTimeout(resolve, 80))
  let list = getStoredLogs()

  // Filter: Module
  if (filters.module && filters.module !== 'Select Modules' && filters.module !== 'All') {
    list = list.filter((l) => l.module.toLowerCase() === filters.module.toLowerCase())
  }

  // Filter: Date Range
  if (filters.fromDate) {
    list = list.filter((l) => l.date.split(' ')[0] >= filters.fromDate)
  }
  if (filters.tillDate) {
    list = list.filter((l) => l.date.split(' ')[0] <= filters.tillDate)
  }

  // Filter: Name Search
  if (filters.name) {
    const q = filters.name.toLowerCase().trim()
    list = list.filter(
      (l) =>
        l.name.toLowerCase().includes(q) ||
        l.remarks.toLowerCase().includes(q) ||
        l.module.toLowerCase().includes(q)
    )
  }

  // Sort: descending by date
  list.sort((a, b) => b.date.localeCompare(a.date))

  return {
    records: list,
    totalRecords: list.length,
  }
}
